module.exports = __webpack_public_path__ + "static/media/1_Comment_icon.33fa062a.svg";